import { useState, useEffect } from "react";
import { FallBackImg } from "image-config";

export interface UseCustomImageParams {
  src: string;
}

export interface UseCustomImageResult {
  error: boolean;
  setError: (error: boolean) => void;
  imageSrc: string;
}

export const useCustomImage = (
  params: Readonly<UseCustomImageParams>
): Readonly<UseCustomImageResult> => {
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    setError(false);
  }, [params.src]);

  const imageSrc = error ? FallBackImg : params.src;

  return {
    error,
    setError,
    imageSrc,
  } as const;
};

